import { testimonials } from "@/mocks/content";

const pillars = [
  {
    icon: "ri-compass-3-line",
    title: "我们的定位",
    desc: "51黑瓜是专注娱乐瓜料聚合的内容平台，将碎片化的热搜与圈内动态整理为清晰可读的信息流。",
  },
  {
    icon: "ri-seedling-line",
    title: "发展理念",
    desc: "始终坚持信息来源可追溯、表达有分寸的原则，不让猎奇淹没事实，让吃瓜更有质量。",
  },
  {
    icon: "ri-file-list-3-line",
    title: "内容原则",
    desc: "大赏求极致、精选求含金量、盘点求脉络、榜单求客观，四个栏目各司其职，共同构成完整内容体系。",
  },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100 py-14 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 max-w-2xl">
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-secondary-600">
            <i className="ri-user-heart-line"></i> About Us
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">关于51黑瓜</h2>
          <p className="mt-3 text-base leading-relaxed text-foreground-600">
            51黑瓜立志做吃瓜人群最可靠的信息管家。与其在碎片里迷路，不如在这里把大赏、精选、盘点、榜单一次看个明白。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {pillars.map((p, i) => (
            <div key={i} className="rounded-2xl border border-background-200 bg-background-50 p-6">
              <span className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-xl text-accent-700">
                <i className={p.icon}></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl border border-accent-200 bg-gradient-to-br from-accent-50 to-background-50 p-8 md:p-12">
          <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">来自吃瓜群众的口碑</h3>
          <p className="mt-2 text-sm text-foreground-600">越来越多网友把这里当作每天必刷的瓜料基地。</p>
          <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
            {testimonials.map((t, i) => (
              <figure key={i} className="rounded-2xl bg-background-50/80 p-6">
                <div className="mb-3 flex items-center gap-0.5 text-secondary-500">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <i key={s} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="text-sm leading-relaxed text-foreground-700">“{t.quote}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-sm font-bold text-primary-700">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}